import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { Button } from "@/components/ui/button";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[55vh] max-w-2xl flex-col items-center justify-center gap-6 text-center">
      <div className="space-y-2">
        <div className="font-display text-5xl font-semibold tracking-tight">
          404
        </div>
        <div className="text-sm text-muted-foreground">
          Bu sayfa bulunamadı:{" "}
          <span className="font-mono">{location.pathname}</span>
        </div>
      </div>
      <Button asChild variant="outline" className="rounded-full">
        <Link to="/">
          <ArrowLeft className="h-4 w-4" /> Ana sayfaya dön
        </Link>
      </Button>
    </div>
  );
}
